import Modal from 'react-modal';
import { DropDown, Input, CheckBox } from '../controls';
import { DataContext } from '../../data/DataContext';
import { typeDocument, txtAcceptTerm,civilStatus } from '../../data/MochaData';
import { useContext, useState } from 'react';
import { ImgError } from '../../img';

const Step1 = () => {

    const { AutoHN, setAutoHN, changeHandler } = useContext(DataContext);
    const [openModalAccept, setOpenModalAccept] = useState(false);

    const OnChangeCbo = (property: string, value: string) => {
        setAutoHN({ ...AutoHN, [property]: value });
    }

    const OnChangeChk = (property: string, value: boolean) => {
        setAutoHN({ ...AutoHN, [property]: value });
    }

    return (
        <>
            {AutoHN.error ?
                <div className='border-autohn pt-20 pr-20 pl-20 mt-20 step-autohn-4'>
                    <div className='img-autohn mt-40 mb-40'>
                        <ImgError />
                    </div>
                    <p className='lbl-end-autohn'>
                        Un ejecutivo de Seguros LAFISE se comunicará con usted lo antes posible
                    </p>
                    <div className='img-autohn mt-30 mb-50'>
                        <button className='button-finish-autohn' onClick={() => window.location.reload()}>
                            Terminar
                        </button>
                    </div>
                </div>
                : 
                <>
                    <DropDown
                        label='Tipo de identificación*'
                        dataProvider={typeDocument}
                        valueSelect={AutoHN.identificationType}
                        field='identificationType'
                        onChangeSelect={OnChangeCbo}
                    />
                    {AutoHN.identificationType === '1' &&
                        <Input
                            id='identification'
                            label='Número de identificación*'
                            value={AutoHN.identification}
                            field='identification'
                            onChange={changeHandler}
                            placeholder="Identificación"
                            type='mask'
                            mask="9999-9999-99999"
                            pattern="\d\d\d\d-\d\d\d\d-\d\d\d\d\d"
                            title="Documento invalido"
                        />
                    }
                    {AutoHN.identificationType !== '1' &&
                        <Input
                            id='identification'
                            label='Número de identificación*'
                            value={AutoHN.identification}
                            field='identification'
                            onChange={changeHandler}
                            placeholder="Identificación"
                        />
                    }
                    <Input
                        id='firstName1'
                        label='Nombres*'
                        value={AutoHN.firstName1}
                        field='firstName1'
                        onChange={changeHandler}
                        placeholder="Primer Nombre"
                        cssClassStyle={"mb-10"}
                    />
                    <Input
                        id='firstName2'
                        label='Nombres*'
                        value={AutoHN.firstName2}
                        field='firstName2'
                        onChange={changeHandler}
                        onlyInput={true}
                        placeholder="Segundo Nombre"
                        isRequired={false}
                    />
                    <Input
                        id='lastName1'
                        label='Apellidos*'
                        value={AutoHN.lastName1}
                        field='lastName1'
                        onChange={changeHandler}
                        placeholder="Primer Apellido"
                        cssClassStyle={"mb-10"}
                    />
                    <Input
                        id='lastName2'
                        label='Nombres*'
                        value={AutoHN.lastName2}
                        field='lastName2'
                        onChange={changeHandler}
                        onlyInput={true}
                        placeholder="Segundo Apellido"
                        isRequired={false}
                    />
                    <Input
                        id='phoneNumber'
                        label='Número de Celular*'
                        value={AutoHN.phoneNumber}
                        field='phoneNumber'
                        onChange={changeHandler}
                        placeholder="0000 0000"
                        type='mask'
                        mask="9999-9999"
                        title="Documento invalido"
                    />
                    <Input
                        id='mail'
                        label='Correo electrónico*'
                        value={AutoHN.mail}
                        field='mail'
                        onChange={changeHandler}
                        placeholder="ejemplo@ejemplo.com"
                    />
                    <DropDown
                        label='Estado civil*'
                        dataProvider={civilStatus}
                        valueSelect={AutoHN.civilStatus}
                        field='civilStatus'
                        onChangeSelect={OnChangeCbo}
                    />
                    <CheckBox
                        label={'Acepto que he leído y consecuentemente brindo mi consentimiento a SEGUROS LAFISE para el uso de mi información según lo indicado en las Políticas de Privacidad, Términos y Condiciones.'}
                        value={AutoHN.acceptTerms}
                        field='acceptTerms'
                        onChange={OnChangeChk}
                        onClickLabel={() => { setOpenModalAccept(true) }}
                    />
                    <Modal className='modal modal-autohn' isOpen={openModalAccept}>
                    <div className='modal-body-autohn'>
                        <p> <strong>Términos y condiciones de uso</strong>     </p>
                        <p>  <strong> 1. AVISO </strong> </p>
                        <p className='modal-label-body-autohn'>
                            {txtAcceptTerm}
                        </p>
                    </div>
                    <div className="modal-footer-autohn">
                        <button className="modal-btn-close-autohn" onClick={() => setOpenModalAccept(false)}>Cerrar</button>
                    </div>
                    </Modal>
                </>
            }
        </>
    );
}

export { Step1 }